export class AddSlideDto {
  constructor(public previewSlideId: number, public parentSlideId: number, public storyId: number) {}
}
